import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { years } from '../../helpers';
import { getAllUnified } from '../../services/factsSvc';
import UnifiedIndex from './UnifiedIndex';
import LoadingTable from '../table/LoadingTable';

const DEFAULT_YEAR = Number(2025);
const months = ['04', '07', '10'];

const UnifiedTable = (props) => {
  const {
    canExport, data, hasChildData, firstCols, tableComponents, tableProps,
  } = props;

  const [filterYears, setFilterYears] = useState([DEFAULT_YEAR]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    stratId, policyId, projId, portfolioId,
  } = useParams();

  const getData = async () => {
    const result = await getAllUnified({
      years: filterYears,
      strategyId: stratId,
      projId,
      policyId,
      portfId: portfolioId,
    });

    let lastUnit = '';

    data.setOriginalData(result.map((e, i) => {
      if (e?.unit) lastUnit = e.unit;
      return ({
        ...e,
        num: i + 1,
        unit: e?.unit ?? lastUnit,
      });
    }));
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [filterYears]);

  return (
    <div>
      <LoadingTable loadingObject={{ isLoading }} spinnerStyle={{ marginTop: 24 }}>
        <UnifiedIndex
          firstCols={firstCols}
          hasChildData={hasChildData}
          canExport={canExport}
          years={years}
          filterState={{ filterYears, setFilterYears }}
          months={months}
          dataState={{
            originalData: data.originalData,
            setOriginalData: data.setOriginalData,
          }}
          tableComponents={tableComponents}
          {...tableProps}
        />
      </LoadingTable>
    </div>
  );
}

export default UnifiedTable;
